import { UpdateEmailPreferencesCTA } from "./ctas";
export var EmailNotificationsIA = function EmailNotificationsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return MANAGE_EMAIL_NOTIFICATIONS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [YOU_CAN_UPDATE_EMAIL_PREFERENCES(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return UpdateEmailPreferencesCTA(strictLocalize);
};
var MANAGE_EMAIL_NOTIFICATIONS = function MANAGE_EMAIL_NOTIFICATIONS(strictLocalize) {
  return strictLocalize({
    id: "KWoi0j",
    defaultMessage: [{
      "type": 0,
      "value": "Gérez les notifications par e-mail"
    }]
  });
};
var YOU_CAN_UPDATE_EMAIL_PREFERENCES = function YOU_CAN_UPDATE_EMAIL_PREFERENCES(strictLocalize) {
  return strictLocalize({
    id: "ckZSKo",
    defaultMessage: [{
      "type": 0,
      "value": "Vous avez la possibilité de sélectionner les e-mails que vous souhaitez et ne souhaitez pas recevoir dans l'onglet « Préférences en matière d'e-mails » situé sous l'onglet « Mon profil » sur la page « Paramètres du compte ». Pour plus d'informations, consultez l'article ci-dessous ou contactez-nous en utilisant l'une des options ci-dessous."
    }]
  });
};